import React from "react";
import { withStyles } from "@material-ui/styles";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";

import { displayData } from "../../../utils/data";

import colors from "../../../assets/style/colors";

const styles = {
  tab: {
    minWidth: "120px",
    textAlign: "center",
    backgroundColor: colors.white,
    borderRadius: "2px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderBottom: "none",
    marginRight: "10px",
    padding: "6px",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: colors.primary,
    paddingRight: "6px",
    maxWidth: "120px",
  },
  inactive: {
    color: colors.black54,
    height: "74px",
    cursor: "pointer",
  },
  active: {
    color: colors.black87,
    height: "76px",
    cursor: "default",
    paddingTop: "4px",
    borderTopWidth: "4px",
  },
  title: {
    marginTop: "5px",
    fontSize: "1.142em",
    textTransform: "uppercase",
  },
  value: {
    fontSize: "1.857em",
    fontWeight: 500,
  },
};

const MdcTab = (props) => {
  const { classes, title, value, onClick, active } = props;

  return (
    <Grid item>
      <Grid
        container
        wrap="nowrap"
        direction="column"
        onClick={onClick}
        className={clsx(classes.tab, {
          [classes.active]: active,
          [classes.inactive]: !active,
        })}
      >
        <Grid item className={classes.title}>
          {title}
        </Grid>
        <Grid item className={classes.value}>
          {displayData(value)}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(MdcTab);
